import { toast } from 'vue3-toastify';
import { h } from 'vue';
import ExportNotificationToast from '@/components/shared/export/ExportNotificationToast.vue';

import SvgIcon from '@/assets/SvgIcon.vue';

export const useExportNotifications = () => {
  const showExportSuccessToast = (p_fileName, p_downloadUrl) => {
    toast(ExportNotificationToast, {
      icon: h(SvgIcon, { icon: 'circle-check' }),
      closeOnClick: false,
      autoClose: false,
      position: toast.POSITION.BOTTOM_RIGHT,
      hideProgressBar: true,
      closeButton: false,
      success: true,
      expandCustomProps: true,
      contentProps: {
        type: 'success',
        success: true,
        fileName: p_fileName,
        downloadUrl: p_downloadUrl,
      },
      style: {
        width: '400px',
      },
    });
  };

  const showExportErrorToast = fileName => {
    toast(ExportNotificationToast, {
      icon: h(SvgIcon, {
        icon: 'circle-x',
      }),
      closeOnClick: false,
      autoClose: false,
      position: toast.POSITION.BOTTOM_RIGHT,
      hideProgressBar: true,
      closeButton: false,
      expandCustomProps: true,
      contentProps: {
        type: 'error',
        success: false,
        fileName: fileName,
      },
      style: {
        width: '400px',
      },
    });
  };

  return {
    showExportSuccessToast,
    showExportErrorToast,
  };
};
